import ProjectBox from "@/components/pages/Community/ProjectBox/ProjectBox";

export default ProjectBox;
